<div class="col-12 px-3 pessoa-vinculada-info" *ngIf="pessoa">
  <div class="row g-3">
    <div class="col-sm-6 form-group">
      <label class="form-label">Nome</label>
      <nz-input-group nzSize="large" [nzDisabled]="true">
        <input nz-input [disabled]="true" readonly [value]="pessoa?.nome" />
      </nz-input-group>
    </div>

    <div class="col-sm-6 form-group" *ngIf="pessoa?.nomeConhecido">
      <label class="form-label">Nome Conhecido</label>
      <nz-input-group nzSize="large" [nzDisabled]="true">
        <input nz-input [disabled]="true" readonly [value]="pessoa?.nomeConhecido" />
      </nz-input-group>
    </div>
  </div>

  <div class="col-12 d-flex flex-column page-content border border-radius w-100 mt-3 mb-2">
    <nz-table [nzData]="pessoa?.pessoaContatos ?? []" [nzSize]="'small'" [nzFrontPagination]="false"
      [nzShowPagination]="false" [nzNoResult]="semDadosPessoaTemplate">
      <thead>
        <tr>
          <th>Tipo Contato</th>
          <th>Principal</th>
          <th>E-mail</th>
          <th>Telefone</th>
          <th>Endereço</th>
          <th>Bairro</th>
          <th>Município</th>
          <th>Estado</th>
          <th>País</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of pessoa?.pessoaContatos">
          <td>{{ item?.tipoContato?.nomeTipoContato }}</td>
          <td>{{ item?.flagPrincipal === true ? 'Sim' : 'Não' }}</td>
          <td>{{ item?.email }}</td>
          <td>{{ item?.telefone | telefoneXX }}</td>
          <td>{{ item?.enderecoLogradouro }}<ng-container *ngIf="item?.enderecoNumero">, {{ item?.enderecoNumero }}</ng-container></td>
          <td>{{ item?.enderecoBairro }}</td>
          <td>{{ item?.enderecoMunicipio?.nome }}</td>
          <td>{{ item?.enderecoUf?.nome }}</td>
          <td>{{ item?.pais?.nome }}</td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #semDadosPessoaTemplate>
      <div class="d-flex align-items-center justify-content-center">
        <nz-empty [nzNotFoundContent]="'Nenhum contato encontrado'"></nz-empty>
      </div>
    </ng-template>
  </div>
</div>
